import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=0fe80c2f"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports